module.exports = __webpack_public_path__ + "img/p5_caihongyunduo.b46373fc.jpg";